import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Router, RouterStateSnapshot } from '@angular/router';
import { UserService } from '../services/user.service';

@Injectable({ providedIn: 'root' })
export class AdminAuthGuard {
	constructor(private router: Router, private userService: UserService) {}

	// A delegated User Access Admin may reach only the administrative-role screens, not the whole
	// admin area; the sidebar already limits them and the server enforces every endpoint, but this
	// keeps them from loading unrelated admin screens by typing the URL directly.
	private static readonly userAccessAdminPaths = [
		'/admin/administrative-roles-management',
		'/admin/temporary-role-assignments',
	];

	canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
		if (this.userService.isAdmin()) {
			// full administrator
			return true;
		}

		if (this.userService.isUserAccessAdmin()) {
			if (AdminAuthGuard.userAccessAdminPaths.some((path) => state.url.startsWith(path))) {
				return true;
			}
			this.router.navigate(['/admin/administrative-roles-management']);
			return false;
		}

		// not logged in so redirect to login page with the return url
		this.router.navigate(['/authentication/login'], { queryParams: { returnUrl: state.url } });
		return false;
	}
}
